let busyCount = 0;

export const setAppBusy = (on) => { busyCount = Math.max(0, busyCount + (on ? 1 : -1)); };
export const isAppBusy = () => busyCount > 0;

const KEY = "enkosta_pending_action";

export function savePending(data) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ ...readPending(), ...data, at: Date.now() })); return true; }
  catch (e) { console.warn("[foto] não deu pra salvar no sessionStorage", e); return false; }
}

export function readPending() {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return p && Date.now() - p.at < 30 * 60 * 1000 ? p : null;
  } catch { return null; }
}

export const clearPending = () => sessionStorage.removeItem(KEY);
